import Router from './vendor/Router';
import common from './routes/common';
import home from './routes/home';
import accommodation from './routes/accommodation';
import facilities from './routes/facilities';
import faqs from './routes/faqs';
// import yourHoliday from './routes/yourholiday';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
	home,
	accommodation,
	facilities,
	faqs,
  // About Us page, note the change from your-holiday to yourHoliday.
  // yourHoliday,
});

routes.loadEvents();
